import React from "react";
import PropTypes from "prop-types";
import axios from "axios/index";
import moment from "moment";
import lodash from "lodash";

import Loading from "../general/Loading.js";
import Pagination from "../general/Pagination";

const PER_PAGE = 10;

class Item extends React.Component {
  render() {
    const { item } = this.props;

    return (
      <tr>
        <td>{item.custom_form.title}</td>

        <td>{item.location ? item.location.name : "All Locations"}</td>

        <td className="hidden-xs">
          {item.user ? (
            <a className="styled-link" href={`/users/${item.user.id}`}>
              {`${item.user.last_name}, ${item.user.first_name}`}
            </a>
          ) : (
            <i>Public Form Submission</i>
          )}
        </td>

        <td className="hidden-xs hidden-sm">
          {moment(item.created_at).format("M/D/YYYY h:mm A")}
        </td>

        <td style={{ textAlign: "right" }}>
          <a href={`/completed_forms/${item.id}`} className="btn btn-text">
            VIEW
          </a>
        </td>
      </tr>
    );
  }
}

const Table = ({ data }) => (
  <table className="table table-clean table-white">
    <thead>
      <tr>
        <th>Form</th>
        <th>Location</th>
        <th className="hidden-xs">Submitted By</th>
        <th className="hidden-xs hidden-sm">Submitted At</th>
        <th />
      </tr>
    </thead>

    <tbody>{data.map(item => <Item key={item.id} item={item} />)}</tbody>
  </table>
);

class ListCompleteForms extends React.Component {
  state = {
    loading: false,
    data: [],
    page: 1,
    totalPages: 0
  };

  componentWillMount() {
    this.loading();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.query !== this.props.query ||
      nextProps.location !== this.props.location ||
      nextProps.accessLevel !== this.props.accessLevel ||
      nextProps.formId !== this.props.formId ||
      nextProps.startDate !== this.props.startDate ||
      nextProps.endDate !== this.props.endDate
    ) {
      this.setState({ page: 1, totalPages: 0 }, () => {
        this.loading();
      });
    }
  }

  render() {
    const { loading, data, page, totalPages } = this.state;

    return (
      <div>
        {data.length === 0 ? null : (
          <div>
            <Table data={data} />

            {totalPages > 1 ? (
              <Pagination
                page={page}
                totalPages={totalPages}
                changePage={this.handlerChangePage}
              />
            ) : null}
          </div>
        )}

        <br />

        <Loading
          loading={loading}
          noDataMessage={data.length === 0 ? "No forms match the current filters." : null}
        />
      </div>
    );
  }

  handlerChangePage = n => {
    this.setState({ page: this.state.page + n }, () => {
      this.loading();
    });
  };

  loading = () => {
    const { query, location, accessLevel, formId, startDate, endDate } = this.props;
    const params = [
      `per_page=${PER_PAGE}`,
      `page=${this.state.page}`,
      `q=${query}`,
      `location_id=${location}`,
      `form_id=${formId}`,
      `access_level=${accessLevel}`,
      `start_date=${startDate}`,
      `end_date=${endDate}`
    ];

    this.setState({ loading: true });
    axios.get(`/completed_forms.json?${params.join("&")}`).then(resp => {
      this.setState({
        data: resp.data,
        totalPages: Math.ceil(parseInt(resp.headers.total) / PER_PAGE),
        loading: false
      });
    });
  };
}

ListCompleteForms.propTypes = {
  query: PropTypes.string,
  location: PropTypes.string,
  accessLevel: PropTypes.string,
  formId: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};

export default ListCompleteForms;
